import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { getLocations, selectLocations } from '../../addressbook/locations';
import Address from '../../addressbook/components/Address';
import Icon from '../../../ui/Icon';
import ImmutablePropTypes from 'react-immutable-proptypes';
import IsSpinning from '../../app/containers/IsSpinning';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Addresses.scss';
import Button from "../../../ui/Button";

export class Detail extends Component {
    static propTypes = {
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        locations: ImmutablePropTypes.map,
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.dispatch(getLocations());
    }

    render() {
        const { locations, spinner } = this.props;

        const list = locations.size === 0 && !spinner.get('locations') ?
            <div className={styles.addressContainer} key={'0'}>
                <h3>
                    <FormattedMessage id='frontend.addressbook.dashboard.no_addresses' />
                </h3>
            </div> : locations.slice(0, 5).map(location => {
                return (
                    <div className={styles.addressContainer} key={location.get('id')}>
                        <Address className={styles.address} location={location} />
                    </div>
                );
            }).toArray();

        return (
            <div className={styles.addresses}>
                {list}
                <IsSpinning id='locations'>
                    <div className={styles.loadingMessage}>
                        <Icon name='refresh' spin fixedWidth />{' '}
                        <FormattedMessage id='common.helper.please_wait' />
                    </div>
                </IsSpinning>
                {(locations.size > 0) ? (
                    <Button link to='/addressbook' emphasis='primary' standalone>
                        <FormattedMessage id='frontend.addressbook.dashboard.display_all' />
                    </Button>) : null}
                {(locations.size === 0 && !spinner.get('locations')) ? (
                    <Button link to='/addressbook/new' emphasis='primary' standalone>
                        <FormattedMessage id='frontend.addressbook.dashboard.new_address' />
                    </Button>) : null}
            </div>
        );
    }
}

export default connect(state => ({
    locations: selectLocations(state),
    spinner: state.spinner,
}))(Detail);
